<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useAdminInfo } from '@/stores/useAdminInfo';
import AppHeader from '@/components/layouts/AppHeader.vue';
import AppSidebar from '@/components/layouts/AppSidebar.vue';
import AppContent from '@/components/layouts/AppContent.vue';

const adminStore = useAdminInfo();
const collapsed = ref(false);
const isMobile = ref(false);
const username = ref('');

const checkScreen = () => {
    isMobile.value = window.innerWidth <= 414;
    if (isMobile.value) {
        collapsed.value = true;
    }
};

onMounted(() => {
    checkScreen();
    window.addEventListener('resize', checkScreen);

    // 監聽收起側邊選單事件
    window.addEventListener('collapse-sidebar', () => {
        collapsed.value = true;
    });

    // 獲取管理員資訊
    const adminInfo = adminStore.getAdminInfo();
    username.value = adminInfo.email || adminInfo.name;
});

onUnmounted(() => {
    window.removeEventListener('resize', checkScreen);
    window.removeEventListener('collapse-sidebar', () => {
        collapsed.value = true;
    });
});
</script>

<template>
    <a-layout class="min-h-screen">
        <!-- 側邊欄 -->
        <AppSidebar v-model:collapsed="collapsed" :is-mobile="isMobile" />

        <!-- 主要內容區域 -->
        <a-layout
            class="transition-all duration-300"
            :style="{
                marginLeft: isMobile ? '0' : collapsed ? '80px' : '200px'
            }"
        >
            <!-- Header -->
            <AppHeader
                v-model:collapsed="collapsed"
                :is-mobile="isMobile"
                :username="username"
            />

            <!-- Content -->
            <AppContent :collapsed="collapsed" :is-mobile="isMobile" />
        </a-layout>
    </a-layout>
</template>
